import { getUserList } from "../../utils/api";

export const getUserDataList = (company_id) => {
    return async (dispatch) => {
        try {
            const response = await getUserList(company_id)
            const dataList = response?.data?.map((item, index) => ({ ...item, id: index })) || []
            dispatch({
                type: 'USER_DATA_LIST',
                payload: dataList
            });
        } catch (error) {
            dispatch({
                type: 'FETCH_ERROR',
                payload: error.message
            });
        }
    };
};

export const clearReduxForUserComponent = () => {
    return async dispatch => {
        dispatch({
            type: 'LOGOUT',
        });
    }
}

export const clearReduxDataForUserComponent = () => {
    return async dispatch => {
        dispatch({
            type: 'CLAER_CACHE_REDUX_USER',
        });
    }
}